<template>
  <div
    class="page-qmulus"
    data-qa="page-qmulus"
  >
    <PageQmulusHeader
      v-if="$slots.header
        || $slots.subheader
        || (!$slots.tab && $slots.actions)"
      class="page-qmulus__header"
    >
      <slot name="header" />
      <template #subheader>
        <slot name="subheader" />
      </template>
      <template #actions>
        <slot name="actions" />
      </template>
    </PageQmulusHeader>
    <PageQmulusTab
      v-else-if="$slots.tab"
      class="page-qmulus__tab"
      data-qa="page-qmulus__tab"
    >
      <slot
        name="tab"
      />
      <template #actions>
        <slot name="actions" />
      </template>
    </PageQmulusTab>
    <PageQmulusTools
      v-if="$slots.tools && hasSlotContent($slots.tools)"
      class="page-qmulus__tools"
      data-qa="page-qmulus__tools"
    >
      <slot name="tools" />
    </PageQmulusTools>
    <div
      class="page-qmulus__content"
      data-qa="page-qmulus__content"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  hasSlotContent,
} from '../../utils/vue.ts';

import PageQmulusHeader from './page-qmulus-header.vue';
import PageQmulusTab from './page-qmulus-tab.vue';
import PageQmulusTools from './page-qmulus-tools.vue';
</script>
<style scoped lang="scss">
@use '../../styles/z-index.scss';

.page-qmulus {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  &__header, &__tools, &__tab {
    // remove the padding from the bottom of the header to use the padding of the content
    padding-bottom: 0;
  }

  &__header {
    position: sticky;
    top: 0;
    z-index: z-index.$app-header;
  }

  &__tools {
    display: flex;
    flex-direction: row;
    gap: var(--gap);

    // vertical align items to bottom (do account for inconsistent usage of labels)
    align-items: flex-end;
  }

  &__content {
    padding: var(--padding-content);
    display: flex;
    flex-direction: column;
    gap: var(--gap-section);
    flex-grow: 1;
  }
}
</style>
